import { render, staticRenderFns } from "./Smain.vue?vue&type=template&id=113554b1&scoped=true"
import script from "./Smain.vue?vue&type=script&lang=js"
export * from "./Smain.vue?vue&type=script&lang=js"
import style0 from "./Smain.vue?vue&type=style&index=0&id=113554b1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "113554b1",
  null
  
)

export default component.exports